var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 207,
    height: 207,
    preserveAspectRatio: "xMidYMid",
    style: {
      margin: "auto",
      display: "block"
    },
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 42.5,
    y: 11.5,
    fill: "#aaa",
    rx: 7.5,
    ry: 7.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.875s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 42.5,
    y: 11.5,
    fill: "#aaa",
    rx: 7.5,
    ry: 7.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.75s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 42.5,
    y: 11.5,
    fill: "#aaa",
    rx: 7.5,
    ry: 7.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.625s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(135 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 42.5,
    y: 11.5,
    fill: "#aaa",
    rx: 7.5,
    ry: 7.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.5s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 42.5,
    y: 11.5,
    fill: "#aaa",
    rx: 7.5,
    ry: 7.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.375s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(225 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 42.5,
    y: 11.5,
    fill: "#aaa",
    rx: 7.5,
    ry: 7.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.25s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 42.5,
    y: 11.5,
    fill: "#aaa",
    rx: 7.5,
    ry: 7.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.125s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(315 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 42.5,
    y: 11.5,
    fill: "#aaa",
    rx: 7.5,
    ry: 7.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.6f7fca75d34621d707eb08e7fd85b794.svg";
export { ForwardRef as ReactComponent };